import React, { useEffect, useRef, useState } from "react";
import { ChevronRight, Clock, X, CircleCheck, AlertTriangle, Calendar } from "lucide-react";
import HeaderModal from "components/modal/HeaderModal";
import { Button, Divider } from "antd";
import IndexModal from "components/modal";
import AnnouncementModal from "../../employee-dashboard/components/AnnouncementModal";

const AnnouncementWidget = ({ announcements, selectedId, setSelectedId, userType = "client", onRemove }) => {


  const handleClick = (id) => {
    setSelectedId(id);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
      {announcements.map((item, id) => {
        const Icon = item.icon;
        const isSelected = selectedId === id;

        return (
          <div
            key={id}
            onClick={() => {
              handleClick(id);
            }}
            className={`
              group relative p-2.5 rounded-lg cursor-pointer transition-all duration-300
              bg-white dark:bg-white/10
              border border-slate-200 dark:border-zinc-700
              ${isSelected
                ? "border-violet-400 shadow-lg shadow-violet-300/40 dark:shadow-violet-800"
                : "hover:border-violet-300 hover:shadow-sm"
              }
            `}
          >
            <button
               onClick={(e) => {
                  e.stopPropagation();
                  onRemove(id);
                }}
              className="absolute top-1.5 right-1.5 p-0.5 rounded opacity-0 group-hover:opacity-100 bg-slate-100 dark:bg-zinc-700 hover:bg-slate-200 transition-all"
            >
              <X className="w-2.5 h-2.5 text-slate-800" />
            </button>


            <div className="flex items-start gap-2 mb-2">
              <div className={`p-1.5 rounded-lg flex-shrink-0 bg-text ${item.category.toLowerCase().replace(/\s+/g, "-")}`}>
                <Icon className="w-3 h-3" />
              </div>

              <div className="flex-1 min-w-0">
                <span className={`status-indicator ${item.priority.toLowerCase()} text-[8px] px-1 py-0 mb-1`}>
                  {item.priority}
                </span>
                <h5 className="text-[11px] leading-tight mb-0.5 line-clamp-1 font-semibold title-text">
                  {item.title}
                </h5>
              </div>
            </div>

            <p className="text-[9px] muted-text line-clamp-2 mb-2">
              {item.description}
            </p>

            <div className="flex items-center justify-between text-[8px] muted-text">
              <span className="flex items-center gap-0.5">
                <Clock className="w-2.5 h-2.5" />
                {item.dateAnnounced}
              </span>
              <ChevronRight className="w-2.5 h-2.5 text-violet-600 dark:text-violet-400" />
            </div>
          </div>
        );
      })}


    </div>
  );
};

export default AnnouncementWidget;
